import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FULL_ROUTE_CONFIG } from '@app/common/full-route-config';
import { CollaborationModule } from '@app/views/collaboration/collaboration.component';
import { FindInformationLightModule } from '@app/views/find-information-light/find-information-light.component';
import { FindInformationModule } from '@app/views/find-information/find-information.component';
import { MyBoardModule } from '@app/views/my-board/my-board.component';
import { TodayModule } from '@app/views/today/today.component';

@NgModule({
  imports: [
    TodayModule,
    MyBoardModule,
    CollaborationModule,
    FindInformationModule,
    FindInformationLightModule,
    RouterModule.forRoot(FULL_ROUTE_CONFIG, {
    scrollPositionRestoration: 'enabled',
    anchorScrolling: 'enabled',
    relativeLinkResolution: 'legacy'
}),
  ]
})
export class FullAppRoutingModule { }
